import React, { useState, useEffect } from "react";
import style from "./Submarcas.module.css";
import { Link } from "@material-ui/core";
import sub1 from "../../../../Assets/img/sub1.png";
import sub2 from "../../../../Assets/img/sub2.png";
import sub6 from "../../../../Assets/img/sub3.png";
import sub3 from "../../../../Assets/img/sub4.png";
import sub5 from "../../../../Assets/img/sub5.png";
import sub4 from "../../../../Assets/img/sub6.png";
import sub7 from "../../../../Assets/img/sub7.png";
import working from "../../../../Assets/img/progress2B.png";
import { useMediaQuery } from "@material-ui/core";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

export const Submarcas = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  let marca1 = {
    logo: sub1,
    text: "Queremos devolverle a nuestros clientes la confianza en las bondades de la naturaleza y la conciencia de la salud por medio del equilibrio mental y corporal a través de nuestras líneas de productos elaborados por excelentes artesanos emprendedores, utilizando ingredientes naturales, contribuyendo al mismo tiempo con el cuidado del medio ambiente al utilizar empaques reciclados y reciclables, totalmente libres de crueldad animal.",
    icon1: (
      <Link
        rel="noopener noreferrer"
        href="https://www.instagram.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <InstagramIcon></InstagramIcon>
      </Link>
    ),

    icon2: (
      <Link
        rel="noopener noreferrer"
        href="https://www.facebook.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <FacebookIcon></FacebookIcon>
      </Link>
    ),
  };

  let marca2 = {
    logo: sub2,
    text: "Más allá de los prejuicios, lo cierto es que la piel de los hombres también requiere de cuidados. Para que la piel cumpla bien sus funciones debe tener una actividad celular correcta, y en la medida en que esa actividad se altera, se deterioraran sus funciones apareciendo una variada sintomatología como sequedad, picor, sensación de ardor y tirantez. Estos son algunos de los motivos por los que ofrecemos una línea de cuidado personal con ingredientes naturales, ya que tienen grandes beneficios, el principal es la seguridad, ya que al no tener químicos entre sus ingredientes, no provocan efectos dañinos.",

    icon1: (
      <Link
        rel="noopener noreferrer"
        href="https://www.instagram.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <InstagramIcon></InstagramIcon>
      </Link>
    ),

    icon2: (
      <Link
        rel="noopener noreferrer"
        href="https://www.facebook.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <FacebookIcon></FacebookIcon>
      </Link>
    ),
  };

  let marca3 = {
    logo: sub3,
    text: "Queremos brindar a nuestros clientes un espacio para relajarse y consentirse con productos, tratamientos y terapias especializadas para la salud emocional y corporal, ya que estamos seguros que es importante escaparse un momento de la rutina para controlar el estrés, porque es necesario buscar un equilibrio entre los deberes laborales como personales, para así poder desempeñar las funciones diarias de una manera óptima.",
    link1: "#",
    icon1: <InstagramIcon></InstagramIcon>,
    link2: "#",
    icon2: <FacebookIcon></FacebookIcon>,
    construccion: true,
  };

  let marca4 = {
    logo: sub4,
    text: "Nos encanta la belleza, y estamos seguros que lucir bien es fundamental para tener una buena autoestima, y de esta manera nuestra felicidad y seguridad aumentan. Ofrecemos accesorios exclusivos con significado, elaborados con materias primas éticas de calidad por creativos artesanos emprendedores.",
    icon1: (
      <Link
        rel="noopener noreferrer"
        href="https://www.instagram.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <InstagramIcon></InstagramIcon>
      </Link>
    ),

    icon2: (
      <Link
        rel="noopener noreferrer"
        href="https://www.facebook.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <FacebookIcon></FacebookIcon>
      </Link>
    ),
  };

  let marca5 = {
    logo: sub5,
    text: "Enamorados del arte y lo que este transmite. En Guatemala contamos con excelentes artistas y diseñadores, por esta razón queremos apoyarlos presentándolos a cada uno de nuestros clientes, y de esta manera preservar nuestra cultura, incentivarlos a continuar expresándose y a que puedas adquirir sus valiosos trabajos.",
    icon1: (
      <Link
        rel="noopener noreferrer"
        href="https://www.instagram.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <InstagramIcon></InstagramIcon>
      </Link>
    ),

    icon2: (
      <Link
        rel="noopener noreferrer"
        href="https://www.facebook.com/visnunatura/"
        target="_blank"
        className={style.link}
      >
        <FacebookIcon></FacebookIcon>
      </Link>
    ),
  };

  let marca6 = {
    logo: sub6,
    text: "Consientes de la necesidad por falta de trabajo, el objetivo de nuestro proyecto es de creación de oportunidades,  brindando conocimiento y herramientas a quién lo solicite y necesite por medio de cursos impartidos por nuestros colaboradores, a precios accesibles. Cierto porcentaje de ventas será destinado para otorgar becas a quien más lo necesite.",
    link1: "#",
    icon1: <InstagramIcon></InstagramIcon>,
    link2: "#",
    icon2: <FacebookIcon></FacebookIcon>,
    construccion: true,
  };

  let marca7 = {
    logo: sub7,
    text: "Espacio destinado como sede para dar rienda suelta a toda la creatividad Visnú. En él encontrarás todos los giros de negocios y podrás visitarlo cada vez que necesites una inyección de buena energía, apoyo tanto en lo emocional, espiritual y oportunidad de crecimiento. ",
    link1: "#",
    icon1: <InstagramIcon></InstagramIcon>,
    link2: "#",
    icon2: <FacebookIcon></FacebookIcon>,
    construccion: true,
  };

  const [marca, setMarca] = useState(marca1);

  const [clicked, setClicked] = useState(1);
  const [showClickHint, setShowClickHint] = useState(true);

  let handle1 = () => {
    setMarca(marca1);
    setClicked(1);
    setShowClickHint(false);
  };
  let handle2 = () => {
    setMarca(marca2);
    setClicked(2);
    setShowClickHint(false);
  };

  let handle3 = () => {
    setMarca(marca3);
    setClicked(3);
    setShowClickHint(false);
  };
  let handle4 = () => {
    setMarca(marca4);
    setClicked(4);
    setShowClickHint(false);
  };
  let handle5 = () => {
    setMarca(marca5);
    setClicked(5);
    setShowClickHint(false);
  };
  let handle6 = () => {
    setMarca(marca6);
    setClicked(6);
    setShowClickHint(false);
  };
  let handle7 = () => {
    setMarca(marca7);
    setClicked(7);
    setShowClickHint(false);
  };

  // Ocultar el hint después de 5 segundos
  useEffect(() => {
    if (!mobile && showClickHint) {
      const timeout = setTimeout(() => {
        setShowClickHint(false);
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [mobile, showClickHint]);

  return (
    <div id="Submarcas" className={style.container}>
      {!mobile && showClickHint && (
        <div className={style.clickHint}>
          <span className={style.clickHintText}>Haz clic para explorar</span>
          <div className={style.clickHintIcon}>
            <span className={style.clickHintPointer}>👆</span>
          </div>
        </div>
      )}
      <div className={!mobile ? style.btnCont : style.btnContMob}>
        <button
          onClick={handle1}
          className={clicked === 1 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub1} alt="" className={style.imgLogo} /> : ""}
          <div className={style.dot}></div>
        </button>
        <button
          onClick={handle2}
          className={clicked === 2 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub2} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot2}></div>
        </button>
        <button
          onClick={handle3}
          className={clicked === 3 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub3} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot4}>
            {clicked === 3 ? (
              <img src={working} alt="" className={style.working} />
            ) : (
              ""
            )}
          </div>
        </button>
        <button
          onClick={handle4}
          className={clicked === 4 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub4} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot6}></div>
        </button>
        <button
          onClick={handle5}
          className={clicked === 5 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub5} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot5}></div>
        </button>
        <button
          onClick={handle6}
          className={clicked === 6 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub6} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot3}>
            {clicked === 6 ? (
              <img src={working} alt="" className={style.working} />
            ) : (
              ""
            )}
          </div>
        </button>
        <button
          onClick={handle7}
          className={clicked === 7 ? style.btnClick : style.btn}
        >
          {!mobile ? <img src={sub7} alt="" className={style.imgLogo} /> : ""}

          <div className={style.dot7}>
            {clicked === 7 ? (
              <img src={working} alt="" className={style.working} />
            ) : (
              ""
            )}
          </div>
        </button>
      </div>

      <div className={!mobile ? style.txtContainer : style.txtContainerMob}>
        <img src={marca.logo} alt="asdasd" className={style.title} />

        <p className={style.text}>{marca.text}</p>
        {!marca.construccion ? (
          <div
            className={!mobile ? style.iconContainer : style.iconContainerMob}
          >
            <span className={style.icon}> {marca.icon1}</span>
            <span className={style.icon}> {marca.icon2}</span>
          </div>
        ) : (
          <p className={style.prox}> Proximamente... </p>
        )}
      </div>
    </div>
  );
};
